module.exports = __webpack_public_path__ + "static/genio-9adf2643fa406b326cc08f54ebbb99d5.png";